module.exports = __webpack_public_path__ + "img/wizard.1fc28413.png";